import { Outlet, useNavigate, useParams, useLocation } from 'react-router';

const TABS = [
  { path: 'settings', label: 'Global Settings' },
  { path: 'monte-carlo', label: 'Parameter Sensitivity / Monte Carlo' },
  { path: 'revisions', label: 'Revisions' },
];

const PathwayControlPanel = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleClose = () => {
    const { pathwayId, projectId, caseId } = params;
    navigate(`/projects/${projectId}/build/pathways/${pathwayId}/${caseId}`, { replace: true });
  };

  return (
    <dialog className="modal absolute w-full h-full flex items-start justify-center top-2" open>
      <div className="modal-box w-[99%] h-[98%] max-w-none p-0 shadow-lg rounded flex flex-col">
        <div className="flex justify-between items-center ml-4 mr-4 border-b">
          <div className="flex items-center">
            <h3 className="font-medium mr-6">Control Panel</h3>
            <div className="flex space-x-4">
              {TABS.map(({ path, label }) => {
                const isActive = pathname.includes(`/control-panel/${path}`);

                return (
                  <div
                    key={path}
                    className={`flex items-center cursor-pointer ${isActive ? 'text-black' : 'text-gray-500'}`}
                    onClick={() => navigate(path)}
                  >
                    <span
                      className={`h-3 w-3 rounded-full ${isActive ? 'bg-orange-500' : 'border border-orange-500'} mr-2`}
                    ></span>
                    <span className="font-medium text-xs">{label}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <button
            className="bg-orange-500 hover:bg-orange-600 text-white rounded px-4 py-1 text-sm font-medium my-2"
            onClick={handleClose}
          >
            Close Panel
          </button>
        </div>

        <div className="p-4 overflow-y-auto flex-grow mb-10">
          <Outlet />
        </div>
      </div>
    </dialog>
  );
};

export default PathwayControlPanel;
